export const environment = {
  production: true,
  apiUrl: 'https://backend.roamingse.trackwalkins.com/v1/roamingse/',
  apiAuthUrl: 'https://backend.roamingse.trackwalkins.com/auth/roamingse/',
  s3PaymentUrl: 'https://s3.amazonaws.com/roamingse-documents/production-payment-slip/',
  s3DocumentUrl: 'https://s3.amazonaws.com/roamingse-documents/production-documents/'
};



// WEBPACK FOOTER //
// /home/ec2-user/jenkins/workspace/new-roamingse/prod/roamingse-frontend/src/environments/environment.ts